<template>
  <div class="east-operate">
    <div class="left">
      <slot name="left"></slot>
    </div>
    <div class="right">
      <slot name="right"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "east-operate"
};
</script>
<style lang="less" scoped>
// .east-operate {
//     min-height: 35px;
//     padding: 5px 8px;
//     .left {
//         float: left;
//         text-align: left;
//     }
//     .right {
//         float: right;
//         text-align: right;
//     }
// }
.east-operate {
  min-height: 35px;
  /*padding: 5px 8px;*/
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left {
    text-align: left;
  }
  .right {
    text-align: right;
  }
}
</style>
